export default __webpack_public_path__ + "static/media/zillow-logo.fbec144f.svg";